export enum ReservationTypes {
  CREATE_RESERVATION = 'CREATE_RESERVATION',
}
